import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

import cloud from "../asset/cloud.svg";

const data = {
  "蘇州廠": {
    "title": "蘇州廠",
    "subtitle": "Suzhou",
    "content": "從事液晶顯示器、AIO、POS機、液晶電視..等產品底座的組裝製造。",
  },
  "鴻嘉駿": {
    "title": "鴻嘉駿",
    "subtitle": "Hong Jiajun",
    "content": "從事沖壓模具的開發與零件的製造。",
  },
  "福州廠": {
    "title": "福州廠",
    "subtitle": "Fuzhou",
    "content":
      "擁有先進的CAD/CAM/CAE模具設計軟體,以及高專業的模具設計人才, 可以自行設計開發高精密度的模具。",
  },
  "中山廠": {
    "title": "中山廠",
    "subtitle": "Zhongshan",
    "content": "從事液晶顯示器、AIO、POS機、液晶電視..等產品底座的組裝製造。",
  },
  "重慶廠": {
    "title": "重慶廠",
    "subtitle": "Chongqing",
    "content":
      "成立於2012年，位於重慶市壁山縣青杠街道，主要從事Monitor、AIO、TV軸承底座的組裝，服務客戶以富士康、廣達、英業達為主。",
  },
  "信鋐": {
    "title": "信鋐",
    "subtitle": "SynX",
    "content": "主要提供ODM、OEM、整機組裝服務",
  },
  "冠皇": {
    "title": "冠皇",
    "subtitle": "DGKH",
    "content":
      "主要從事五金零件生產製造，服務多家資訊、家電、汽車廠商客戶，亦提供集團關系企業組裝軸承底座所需之自製五金零件需求。",
  },
  "敬得": {
    "title": "敬得",
    "subtitle": "GateTech",
    "content":
      "從事輕金屬成型業已逾20年，主要提供客戶鋁合金及鎂合金壓鑄之全製程服務，廠內壓鑄機大多為歐、美進口精度極高之設備",
  },
  "越南廠": {
    "title": "越南廠",
    "subtitle": "Vietnam",
    "content":
      "主要從事Monitor、AIO、TV軸承底座的組裝及塑膠產品射出，服務客戶以DELL、Sony、三星為主。",
  },
  "泰國廠": {
    "title": "泰國廠",
    "subtitle": "Thailand",
    "content":
      "主要從事Monitor、AIO、TV軸承底座的組裝及塑膠產品射出，服務客戶以DELL、HP、ASUS為主。",
  },
};

const Glass = ({ s_hoverPlant, s_data }) => {
  const show = s_hoverPlant !== "" && data[s_hoverPlant];

  const [showData, setShowData] = useState(null);

  useEffect(() => {
    if (data[s_hoverPlant]) setShowData(data[s_hoverPlant]);
  }, [s_hoverPlant]);

  // return <div className="glow-text">Hello, World!</div>;

  return (
    <>
      <div
        className={`
        right-card z-9999 w-[300px] h-[8rem]
        fixed top-[18%] right-[10%] xl:right-[50px] py-2 px-2 xl:px-6 xl:py-6
        flex flex-col gap-2 justify-center items-center text-white 
        transition-opacity duration-500 ease-in-out text-[#52C6DE] text-xl
        ${show ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}
      `}
        style={{
          transition: "opacity 0.5s",
          textShadow: "0 0 30px #2CB3CF,0 0 0px #2CB3CF,0 0 0px #2CB3CF",
        }}
      >
        {dayjs().format("YYYY年MM月DD日 HH:mm")}
        <div className="w-full flex justify-center items-center gap-2">
          <img src={cloud} alt="cloud" />
          <span
            className="text-[50px] font-bold text-white"
            style={{ textShadow: "0 0 30px white,0 0 0px white, 0 0px white" }}
          >
            {s_data[s_hoverPlant]?.temperature_2m}
          </span>
        </div>
      </div>
      <div
        className={`
        right-card z-9999 w-[300px] max-h-[14rem]
        fixed top-[50%] 2xl:top-[40%] right-[10%] xl:right-[50px] py-2 px-2 xl:px-6 xl:py-6
        flex flex-col gap-2 justify-center items-center text-white text-2xl
        transition-opacity duration-500 ease-in-out
        ${show ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}
      `}
        style={{ transition: "opacity 0.5s" }}
      >
        <div className="w-full flex justify-start items-end gap-[15px]">
          <span
            className="text-4xl font-bold text-[#2CB3CF]"
            style={{ textShadow: "0 0 30px #2CB3CF,0 0 0px #2CB3CF,0 0 0px #2CB3CF" }}
          >
            {showData?.title}
          </span>
          <span
            className="text-[12px] font-thin text-[#9DB6BC]"
            style={{ textShadow: "0 0 30px #9DB6BC,0 0 0px #9DB6BC,0 0 0px #9DB6BC" }}
          >
            {showData?.subtitle}
          </span>
        </div>
        <span
          className="text-xl text-[#AEDEE8]"
          style={{ textShadow: "0 0 50px #9DB6BC,0 0 2px #9DB6BC,0 0 0px #9DB6BC" }}
        >
          {showData?.content}
        </span>
      </div>
    </>
  );
};

export default Glass;
